import { createContext, useContext } from 'react';
import type { LiveStatus } from '../api/sse';
import type { LiveFailure } from '../api/userJobsSubscription';

// Context + hook for the app-wide live (SSE) channel, split out of LiveStatusProvider.tsx so
// that file has a single component export (react-refresh/only-export-components).
//
// WHY a context rather than a hook each consumer calls: `useUserJobsSubscription` opens a real
// EventSource per call, so calling it from both `Header` (the RefreshPill) and the shell (the
// banner) would open TWO streams for one user and double the server's fan-out. One subscription
// at the shell, broadcast. A1EE-364.

export interface LiveStatusValue {
  status: LiveStatus | null;
  failure: LiveFailure | null;
}

export const LiveStatusContext = createContext<LiveStatusValue | null>(null);

export function useLiveStatus(): LiveStatusValue {
  const ctx = useContext(LiveStatusContext);
  if (!ctx) throw new Error('useLiveStatus must be used within a LiveStatusProvider');
  return ctx;
}
